//hooks
import useFetch from "hooks/useFetch"

//constatns
import { ENDPOINTS } from "constants/endpoints"

//providers
import { useAppContext } from "providers/app"
import { useUsersDataContext } from "../providers/users"

function useCreateSum(successCB) {
    const app = useAppContext()
    const users = useUsersDataContext()

    const { fetch, loading, validations, handleValidations } = useFetch()
    function handleSubmit(e) {
        e.preventDefault()
        const data = new FormData(e.target)

        fetch({ endpoint: ENDPOINTS.ADMIN.CREATE_ADVANCE, method: 'post', data })
            .then(() => {
                users.refetchData()
                app
                    .handleMessage()
                    .success()
                    .show('Плащането беше добавено успешно!')
                successCB()
            })
    }

    return {
        handleSubmit,
        loading,
        validations,
        handleValidations
    }
}

export default useCreateSum